import { defineComponent as _defineComponent } from 'vue'
import type { ListElements } from '@/typings/customilyElements/layer';
import { useLayerTreeItem } from '@/components/Layers/composables/useLayerTreeItem';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseLayersTreeItem',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
    item: ListElements;
};



const {
    flags,
    isSelected,
    isActiveEps,
    isActive,
    itemStyle,
    isPrintArea,
    isProductGuidelines,
    isOverlay,
    onElementClick
} = useLayerTreeItem(props);

return { __sfc: true,props, flags, isSelected, isActiveEps, isActive, itemStyle, isPrintArea, isProductGuidelines, isOverlay, onElementClick }
}

})